export default __webpack_public_path__ + "static/media/the-one-ring.add5c861.png";